/* eslint-disable */
import Cookies from 'js-cookie'

const TokenKey = 'MYJ-ERP-TOKEN'
const UserKey = 'MYJ-ERP-USER'
const UserMenu = 'MYJ-ERP-MENU'
const LoginKey = 'MYJ-ERP-LOGIN'
const CompanyIdKey = 'MYJ-ERP-COMPANY-ID'
const BudgetIdKey = 'MYJ-ERP-BUDGET-ID'
const BudgetGroupIdKey = 'MYJ-ERP-BUDGET-GROUP-ID'
const CompanyListKey = 'MYJ-ERP-COMPANY-LIST'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}
export function getLogin() {
  return Cookies.get(LoginKey)
}
export function getCompanyId() {
  return Cookies.get(CompanyIdKey)
}
export function getBudgetId() {
  return Cookies.get(BudgetIdKey)
}
export function getBudgetGroupId() {
  return Cookies.get(BudgetGroupIdKey)
}
export function getCompanyList() {
  return Cookies.get(CompanyListKey) ? JSON.parse(Cookies.get(CompanyListKey)) : ''
}

export function getMenu() {
  return Cookies.get(UserMenu)
}

export function setLogin(isLogin) {
  return Cookies.set(LoginKey, isLogin)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: 30
  })
}

export function setUser(user) {
  return Cookies.set(UserKey, user, {
    expires: 30
  })
}
export function setCompanyId(companyId) {
  return Cookies.set(CompanyIdKey, companyId, {
    expires: 30
  })
}
export function setQuotationTemplateId(quotationTemplateId) {
  return Cookies.set(CompanyIdKey, quotationTemplateId, {
    expires: 30
  })
}
export function setBudgetId(budgetId) {
  return Cookies.set(BudgetIdKey, budgetId, {
    expires: 30
  })
}
export function setBudgetGroupId(budgetGroupId) {
  return Cookies.set(BudgetGroupIdKey, budgetGroupId, {
    expires: 30
  })
}

export function setMenu(menu) {
  return Cookies.set(UserMenu, menu, {
    expires: 30
  })
}

export function setCompanyList(companyList) {
  return Cookies.set(CompanyListKey, JSON.stringify(companyList), {
    expires: 30
  })
}


export function removeUserInfo() {
  Cookies.remove(TokenKey)
  Cookies.remove(UserMenu)
  Cookies.remove(CompanyIdKey)
  return Cookies.remove(UserKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js